import Image from 'next/image'
import type { HeroData } from '@/data/solutions/types'
import Link from '@/atoms/Link/Link'

type HeroProps = HeroData

export const Hero = ({
  heading,
  subtext,
  primaryCTA,
  secondaryCTA,
  heroImage
}: HeroProps) => {
  return (
    <div className="grid grid-rows-[auto_auto] md:grid-cols-2 gap-8 md:gap-x-16 | items-center">
      <div>
        <h1
          className="text-h3 md:text-h1 font-medium | mb-3"
          dangerouslySetInnerHTML={{ __html: heading }}
        />
        <p className="mb-10 md:mb-14 | text-base">{subtext}</p>
        <div className="flex flex-col md:flex-row | items-stretch | gap-5 md:gap-8">
          <Link
            href={primaryCTA.href}
            className="block | rounded-[40px] bg-black text-white | py-2 px-6 | text-center"
          >
            {primaryCTA.text}
          </Link>
          <Link
            href={secondaryCTA.href}
            className="flex items-center justify-center | gap-3 | text-center"
          >
            {secondaryCTA.text}
            <div>
              <svg
                width="16"
                height="8"
                viewBox="0 0 16 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 4L1 3.5ZM15.3536 4.35355C15.5488 4.15829 15.5488 3.84171 15.3536 3.64645L12.1716 0.464467C11.9763 0.269205 11.6597 0.269205 11.4645 0.464467C11.2692 0.659729 11.2692 0.976312 11.4645 1.17157L14.2929 4L11.4645 6.82843C11.2692 7.02369 11.2692 7.34027 11.4645 7.53553C11.6597 7.7308 11.9763 7.7308 12.1716 7.53553L15.3536 4.35355ZM1 4L1 4.5L15 4.5L15 4L15 3.5L1 3.5L1 4Z"
                  fill="#151515"
                />
              </svg>
            </div>
          </Link>
        </div>
      </div>
      <div className="row-[1/1] md:col-[2/3]">
        <Image width={'752'} height={'642'} src={heroImage} alt="Hero image" />
      </div>
    </div>
  )
}
